// PDF del "Reporte de Pagos y Salidas de Dinero": un solo documento con los filtros aplicados.
// Se usa tanto para descargar como para imprimir (mismo formato).
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { toMoney } from '../utils/numbers';
import { formatDate, formatDateTime } from '../utils/dates';

const MARCA = [31, 45, 51]; // encabezados de tabla (color del menú)
const ACENTO = [47, 111, 115]; // color principal
const OSCURO = [31, 41, 51];
const GRIS = [91, 107, 115];
const fecha = formatDate;
export const fechaHoraMov = (m) => (m.fechaAt
  ? formatDateTime(m.fechaAt)
  : fecha(m.fecha));

/**
 * @param {object} rep   { desde, hasta, movimientos (ya filtrados), resumen }
 * @param {object} meta  { sucursal, filtros: string[], generadoPor, todas }
 * @param {object} opts  { imprimir: true abre el diálogo de impresión en lugar de descargar }
 */
export function exportReportePagosPdf(rep, meta, { imprimir = false } = {}) {
  const pdf = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  const W = pdf.internal.pageSize.getWidth(), H = pdf.internal.pageSize.getHeight(), M = 36;
  let y = M;
  const tabla = (opts) => { autoTable(pdf, { startY: y, margin: { left: M, right: M, bottom: 44 }, theme: 'grid',
    styles: { fontSize: 8.5, cellPadding: 3.5, textColor: [31, 41, 51], lineColor: [217, 226, 227] },
    headStyles: { fillColor: MARCA, textColor: 255, fontStyle: 'bold' }, ...opts }); y = pdf.lastAutoTable.finalY + 16; };
  const titulo = (txt) => { pdf.setFont('helvetica', 'bold'); pdf.setFontSize(12); pdf.setTextColor(...OSCURO); pdf.text(txt, M, y); y += 8; };

  // Encabezado
  pdf.setFillColor(...ACENTO); pdf.rect(0, 0, W, 6, 'F');
  pdf.setFont('helvetica', 'bold'); pdf.setFontSize(20); pdf.setTextColor(...OSCURO); pdf.text('QUE TACO', M, y + 12); y += 32;
  pdf.setFontSize(14); pdf.text('Reporte de Pagos y Salidas de Dinero', M, y); y += 18;
  pdf.setFont('helvetica', 'normal'); pdf.setFontSize(10); pdf.setTextColor(...GRIS);
  [`Sucursal: ${meta.sucursal}`, `Periodo: ${rep.desde === rep.hasta ? fecha(rep.desde) : `${fecha(rep.desde)} al ${fecha(rep.hasta)}`}`,
    ...(meta.filtros || []), `Generado: ${formatDateTime(new Date())}${meta.generadoPor ? ` por ${meta.generadoPor}` : ''}`]
    .forEach((t) => { pdf.text(t, M, y); y += 13; });
  y += 8;

  // Resumen de totales
  const r = rep.resumen;
  titulo('Resumen');
  const num = (v) => ({ content: v, styles: { halign: 'right' } });
  tabla({ head: [['Total pagado', 'Pagos a proveedores', 'Gastos', 'Otros pagos', 'Movimientos']].map((h) => h.map(num)),
    body: [[toMoney(r.total), toMoney(r.proveedor), toMoney(r.gasto), toMoney(r.otro), String(r.cantidad)].map(num)],
    bodyStyles: { fontStyle: 'bold', fontSize: 10 } });

  // Detalle de movimientos
  titulo('Detalle de movimientos');
  const head = ['Fecha y hora', ...(meta.todas ? ['Sucursal'] : []), 'Tipo', 'Beneficiario / proveedor', 'Descripción', 'Forma de pago', 'Pagado por', 'Referencia', { content: 'Monto', styles: { halign: 'right' } }];
  tabla({ head: [head],
    body: rep.movimientos.length ? rep.movimientos.map((m) => [fechaHoraMov(m), ...(meta.todas ? [m.sucursal] : []), m.tipo, m.beneficiario || '—',
      m.descripcion || '—', m.formaPago, m.pagadoPor || 'Sucursal', m.referencia || '—', num(toMoney(m.monto))])
      : [[{ content: 'Sin movimientos con los filtros seleccionados', colSpan: head.length, styles: { textColor: GRIS, fontStyle: 'italic' } }]],
    foot: [[{ content: 'Total general', colSpan: head.length - 1, styles: { halign: 'right' } }, num(toMoney(r.total))]],
    footStyles: { fillColor: [231, 240, 240], textColor: OSCURO, fontStyle: 'bold' },
    columnStyles: { 0: { cellWidth: 96 }, [head.length - 1]: { cellWidth: 78 } } });

  // Pie de página
  const total = pdf.getNumberOfPages();
  for (let i = 1; i <= total; i += 1) {
    pdf.setPage(i); pdf.setFont('helvetica', 'normal'); pdf.setFontSize(8); pdf.setTextColor(...GRIS);
    pdf.text(`Que Taco · Reporte de Pagos y Salidas de Dinero · ${meta.sucursal}`, M, H - 22);
    pdf.text(`Página ${i} de ${total}`, W - M, H - 22, { align: 'right' });
  }

  if (imprimir) {
    pdf.autoPrint();
    const url = pdf.output('bloburl');
    const w = window.open(url, '_blank');
    if (!w) pdf.save('Reporte_Pagos.pdf'); // ventana bloqueada: al menos lo descarga
    return;
  }
  const suc = String(meta.sucursal || '').replace(/[^\w-]+/g, '_');
  pdf.save(`Reporte_Pagos_${suc}_${rep.desde}${rep.desde !== rep.hasta ? `_al_${rep.hasta}` : ''}.pdf`);
}
